import React from "react"
import HubSpotForm from "../hubspot-form/hubspot-form"
import * as styles from "./footer-newsletter.module.css"

const FooterNewsletter = () => {
  return (
    <section className={styles.wrapper} aria-labelledby="footer-newsletter-heading">
      <h3 id="footer-newsletter-heading" className={styles.heading}>
        Altijd op de hoogte van het laatste ondernemersnieuws?
      </h3>

      <p className={styles.copy}>Meld je aan voor onze nieuwsbrief</p>

      <div className={styles.formShell}>
        <HubSpotForm
          formId="1f0705a4-9d0f-4a81-a130-a31651b9b0a4"
          idModifier="footer"
        />
      </div>
    </section>
  )
}

export default FooterNewsletter
